function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Icons-/-Energie/-Kostenbesparing-warmte",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("g", {
  id: "Energiebesparing-tot-heden",
  transform: "translate(1.218750, 4.000000)",
  strokeWidth: 2
}, /*#__PURE__*/React.createElement("path", {
  d: "M10.96875,14.253125 C11.3052985,14.253125 11.578125,14.5259515 11.578125,14.8625",
  id: "Path",
  stroke: "#485156"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.359375,14.8625 C10.359375,14.5259515 10.6322015,14.253125 10.96875,14.253125",
  id: "Path",
  stroke: "#485156"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.96875,15.471875 C10.6322015,15.471875 10.359375,15.1990485 10.359375,14.8625",
  id: "Path",
  stroke: "#485156"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.578125,14.8625 C11.578125,15.1990485 11.3052985,15.471875 10.96875,15.471875",
  id: "Path",
  stroke: "#485156"
}), /*#__PURE__*/React.createElement("line", {
  x1: 8.549125,
  y1: 30.6315,
  x2: 7.3125,
  y2: 35.58125,
  id: "Path",
  stroke: "#485156"
}), /*#__PURE__*/React.createElement("line", {
  x1: 25.5775,
  y1: 30.638,
  x2: 26.8125,
  y2: 35.58125,
  id: "Path",
  stroke: "#485156"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.437125,6.7635 L10.244,4.103375 C9.90202801,3.8172794 9.43099502,3.74106695 9.01625316,3.90472734 C8.6015113,4.06838773 8.30945162,4.44572254 8.255,4.88825 L7.684625,9.456125 C5.47511443,11.1251841 3.84000392,13.4406914 3.00625,16.08125 L0,16.08125 L0,25.83125 L4.04625,25.83125 C6.74921199,30.4372874 11.7226584,33.2313584 17.0625,33.14375 C25.140375,33.14375 31.6875082,27.141 31.6875082,19.7375 C31.6879743,19.3304972 31.6679071,18.9237298 31.627375,18.51875",
  id: "Path",
  stroke: "#485156"
}), /*#__PURE__*/React.createElement("path", {
  d: "M22.9714452,-1 C23.8366955,-1 24.6200327,-0.649288005 25.1870573,-0.0822634248 C25.7540818,0.484761155 26.1047938,1.26809832 26.1047938,2.13334866 L26.1047938,2.13334866 L26.1047938,10.0176198 C26.785947,10.7778785 27.1692589,11.7663893 27.1714704,12.7986678 C27.1728423,13.7619713 26.8460552,14.6638238 26.2853115,15.3833476 C25.7245679,16.1028714 24.9298678,16.6400665 23.9954138,16.8740557 C23.0609592,17.108045 22.1068797,17.0087474 21.2732262,16.6383829 C20.4395726,16.2680184 19.7263451,15.6265871 19.2735945,14.7763088 C18.8208439,13.9260305 18.6867738,12.9762132 18.8448311,12.077789 C18.9769563,11.3267675 19.313215,10.6116586 19.8380965,10.0206271 L19.8380965,10.0206271 L19.8380965,2.13334866 C19.8380965,1.26809832 20.1888085,0.484761155 20.7558331,-0.0822634248 C21.3228577,-0.649288005 22.1061948,-1 22.9714452,-1 Z",
  id: "Path",
  stroke: "#425CD4"
}), /*#__PURE__*/React.createElement("line", {
  x1: 22.9714452,
  y1: 2.13334866,
  x2: 22.9714452,
  y2: 11.7334176,
  id: "Path",
  stroke: "#425CD4"
}), /*#__PURE__*/React.createElement("line", {
  x1: 29.6538326,
  y1: 5.86670882,
  x2: 31.3605115,
  y2: 5.86670882,
  id: "Path",
  stroke: "#425CD4"
}), /*#__PURE__*/React.createElement("line", {
  x1: 29.6538326,
  y1: 1.42433748,
  x2: 31.3605115,
  y2: 1.42433748,
  id: "Path",
  stroke: "#425CD4"
})));
function SvgKostenbesparingwarmte(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "43px",
    viewBox: "0 0 40 43",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons / Energie/ Kostenbesparing warmte") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKostenbesparingwarmte);
export default __webpack_public_path__ + "static/media/Kostenbesparing warmte.7ad8e034686f9b85dc94fc478ed744e3.svg";
export { ForwardRef as ReactComponent };